import { render, staticRenderFns } from "./FileRename.vue?vue&type=template&id=3454e2f6&scoped=true"
import script from "./FileRename.vue?vue&type=script&lang=js"
export * from "./FileRename.vue?vue&type=script&lang=js"
import style0 from "./FileRename.vue?vue&type=style&index=0&id=3454e2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454e2f6",
  null
  
)

export default component.exports